import {
  EARTHQUAKE_DATA_DELETE_EARTHQUAKE_REQUEST,
  EARTHQUAKE_DATA_CLEAR,
  EARTHQUAKE_DATA_REGION_REQUEST,
  EARTHQUAKE_DATA_TOGGLE_COLUMN,
  EARTHQUAKE_DATA_BULK_EDIT_REQUEST,
  EARTHQUAKE_DATA_CANCEL_EDIT,
  EARTHQUAKE_DATA_EDIT,
  EARTHQUAKE_DATA_SAVE_CANCEL_CONFIRMATION,
  EARTHQUAKE_DATA_SAVE_OPEN_CONFIRMATION,
} from './earthquakeDataReducer';
import { EARTHQUAKE_DATA_SORT } from '../search/earthquakeSearchReducer';


export const deleteEarthquake = ({ id, history }) => ({ type: EARTHQUAKE_DATA_DELETE_EARTHQUAKE_REQUEST, id, history });
export const clearEarthquakeData = () => ({ type: EARTHQUAKE_DATA_CLEAR });
export const getRegions = ({ history }) => ({ type: EARTHQUAKE_DATA_REGION_REQUEST, history });
export const sortData = sort => ({ type: EARTHQUAKE_DATA_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: EARTHQUAKE_DATA_TOGGLE_COLUMN, visibleColumns });

export const bulkEditEarthquakes = ({ data }) => ({ type: EARTHQUAKE_DATA_BULK_EDIT_REQUEST, data });
export const openEditConfirmation = ({ formData, initialFormData }) => ({ type: EARTHQUAKE_DATA_SAVE_OPEN_CONFIRMATION, formData, initialFormData });
export const cancelEditConfirmation = () => ({ type: EARTHQUAKE_DATA_SAVE_CANCEL_CONFIRMATION });
export const startEdit = ({ initialValues }) => ({ type: EARTHQUAKE_DATA_EDIT, initialValues });
export const cancelEdit = () => ({ type: EARTHQUAKE_DATA_CANCEL_EDIT });
